/* Juno: ātrā pievienošana grozam no kartītēm un paziņojums pēc pievienošanas. */
(function () {
  if (window.__junoShop) return;
  window.__junoShop = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var toast, timer;

  function showToast(text, withLink) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'juno-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<span>' + text + '</span>' + (withLink ? '<a href="' + root + 'cart">Skatīt grozu</a>' : '');
    toast.classList.add('is-on');
    clearTimeout(timer);
    timer = setTimeout(function () { toast.classList.remove('is-on'); }, 4500);
  }
  window.junoToast = showToast;

  // Pēc jebkuras pievienošanas (kartīte vai produkta lapa) parāda saiti uz grozu
  document.addEventListener('theme:update:cart', function () {
    if (location.pathname.indexOf('/cart') !== -1) return;
    showToast('Pievienots grozam', true);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-juno-add]');
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-busy') === 'true') return;
    b.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-juno-add'), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || '');
        b.classList.add('is-done');
        setTimeout(function () { b.classList.remove('is-done'); }, 1800);
        document.dispatchEvent(new CustomEvent('theme:update:cart'));
      })
      .catch(function (err) { showToast(err.message || 'Neizdevās pievienot grozam. Pamēģini vēlreiz.', false); })
      .finally(function () { b.removeAttribute('aria-busy'); });
  });
})();
